<template>
  <div class="MyPulish">
    <top-component></top-component>
    <div class="titlePu">
      <div>供应商期货</div>
    </div>
    <div class="container">
      <div class="search_code">
       <span>首字母排序：</span>
        <ul>
           <li  v-for="(item, i) in zmArr" :key="i" @click="changeWord(item,i)" :class="{'current':i==index}" >{{item}}</li>
        </ul>
      </div>
      <div class="ListDataContainer" v-if="pages.total > 0">
        <div class="ListDiv clear" v-for="(item, index) in tableData" @click="PubliClick(item)" :key="index">
            <span :title="item.name">{{item.name}}</span>
            <em>({{item.total}})</em>
        </div>
      </div>
    <div class="none_data" v-else>暂无数据！</div>
      <el-pagination v-if="pages.total > 0" @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="pages.pageNum" :page-size="pages.pageSize" layout="prev, pager, next, jumper"
        :total="pages.total">
      </el-pagination>
    </div>
    <bottom-component></bottom-component>
  </div>
</template>

<script>
  import BottomComponent from '../Components/BottomComponent.vue'
  import TopComponent from '../Components/TopComponent.vue'
  // import { searchpage,searchpageCity } from '@/api/img' // 如果不需要，可以注释或删除
  import Axios from "@/api/diyaxios";

  import Cookies from 'js-cookie'
  export default {
    name: 'HelloWorld',
    data() {
      return {
        tableData: [],
        zm:'',
        zmArr:['全部','A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'],
        index:0,
        firstword:'',
        pages: {
          currentPage: 1,
          pageSize: 64,
          total: 0 // 将硬编码的200改为0，等待API返回实际总数
        }
      }
    },
    mounted() {
      this.ApiData()
    },
    methods: {
      changeWord(item,i){
        // 只有当点击的字母不同时才执行
        if(this.index !== i){
          this.firstword = item !== '全部' ? item : '';
          this.pages.currentPage = 1; // 切换字母时，重置为第一页
          this.index = i;
          this.ApiData();
        }
      },
      // 出版社数目
      async ApiData() {
        let vm = this;
        var obj = {
          firstword:vm.firstword,
          currentPage: vm.pages.currentPage,
          pageSize: vm.pages.pageSize
        };

        try {
          const res = await Axios.post('/rmdsupport/action/getGongyingshangList', { params: obj },
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
          );
          if (res.data && res.data.data) {
            vm.tableData = res.data.data;
            vm.pages.total = res.data.total; // 💡 关键修复：从API返回的数据中获取总数
          } else {
            vm.tableData = [];
            vm.pages.total = 0; // 如果没有数据，将总数设为0
          }
        } catch (err) {
          console.error("API请求失败:", err);
          vm.tableData = [];
          vm.pages.total = 0;
        }
      },
      // 分页
      handleSizeChange(val) {
        this.pages.pageSize = val;
        this.ApiData();
      },
      handleCurrentChange(val) {
        this.pages.currentPage = val;
        this.ApiData();
      },
      // 行点击
      PubliClick(item) {
        if (item.gid !== null) {
            const { href } = this.$router.resolve({
                name: 'supplierdetails',
                query: {
                    obj: JSON.stringify({ pubname2: item.name, pubid: item.pkid, goodsType: 1 })
                }
            });
            window.open(href, '_blank');
        } else {
          this.$message({
            message: '数据异常，请稍后再试',  
            type: 'error'
          })
        }
      }
    },
    components: {
      BottomComponent,
      TopComponent
    }
  }
</script>

<style scoped lang="scss">
 .search_code{
   >span{
     float: left;
   }
   >ul{
     float: left;
   }
   padding-left: 11px;
   height: 40px;
   line-height: 40px;
   margin-top: 10px;
   li {
      list-style: none;
      float: left;
      cursor: pointer;
      padding: 0 10px;
      &.current{
        color:#ff7f00;
        font-weight: bold;
      }
    }
 }
  .MyPulish {
    width: 100%;
    background-color: #f9f9f9;
    overflow-x: hidden;
  }

  /* 1、title */
  .titlePu {
    height: 90px;
    width: 100%;
    background-image: url('../../assets/images/TopChild.png');
  }

  .titlePu>div {
    width: 1200px;
    height: 100%;
    margin: 0px auto;
    display: flex;
    align-items: center;
    color: rgba(51, 51, 51, 1);
    font-size: 24px;
    text-align: left;
    font-weight: 500;
    font-family: PingFang-SC-Bold;
  }

  /* 2、内容 */
  .container {
    width: 1200px;
    margin: 0px auto;
  }

  .ListDataContainer {
    height: 600px;
    width: 100%;
    font-size: 0px;
  }

  .ListDiv {
    width: calc(16.6% - 26px);
    padding: 0 8px;
    margin-left: 10px;
    display: inline-block;
    margin-top: 10px;
    border-radius: 4px;
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
    color: rgba(102, 102, 102, 1);
    font-size: 14px;
    text-align: left;
    font-family: PingFangSC-Regular;
    cursor: pointer;
    span{
        float: left;
        display: inline-block;
        height: 45px;
        line-height: 45px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: calc(100% - 46px);
    }
    em{
        float: left;
        display: inline-block;
        height: 45px;
        line-height: 45px;
        font-style: normal;
        color:#ff7f00;
    }
  }

  .ListDiv:hover {
    color: #175199;
    cursor: pointer;
  }
.none_data{
    height:300px;
    text-align: center;
    padding-top:300px;
}
  .el-pagination {
    margin-top: 50px;
    text-align: right;
  }
</style>


// WEBPACK FOOTER //
// src/views/ChildPages/Publisher-Book.vue